import { render, staticRenderFns } from "./RemoverPagina.vue?vue&type=template&id=e8f18d88"
import script from "./RemoverPagina.vue?vue&type=script&lang=js"
export * from "./RemoverPagina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports